import useStore from './useStore';
import logOut from '../utils/logOut';
import ContentStore from '../stores/ContentStore';

const useLogout = () => {
  const contentStore: ContentStore = useStore(ContentStore);
  const { authenticationStore, filterStore } = contentStore.rootStore;
  const logout = (): void => {
    filterStore.resetFilters();
    logOut(authenticationStore);
  };
  return logout;
};

export default useLogout;
